import request from "../../request";
// function addslashes(str) {
//   return (str + "").replace(/[\\"']/g, "\\$&").replace(/\u0000/g, "\\0");
// }
export const getData = async name => {
  let newsPromise = request(
    {},

    "/api/lajm/GetAllLajmet?$filter=contains(titulli,'" +
      name +
      "')" +
      escape("OR contains(nentitulli,'" + name + "')") +
      escape("OR contains(permbajtja,'" + name + "')"),
    "index"
  );
  let response = await Promise.all([newsPromise, newsPromise]);
  var newResponse = [];
  response.map(promise => {
    console.log(promise);
    newResponse = newResponse.concat(promise);
    return true;
  });
  console.log(newResponse);
  return newResponse;
};
